import React, { Component } from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { BootstrapTable, TableHeaderColumn } from "react-bootstrap-table";
import style from "./BillingComponent.module.css";
import moment from "moment";
import { fetchProceduresList, fetchProcedureLookup } from "../../../redux";
import ttmLoader from "../../../assets/images/ttm-loader.gif";
import { LineItemObj,flateRateConsulations } from "../../../utils/BillingConstants";
import { showAlert, getValWithVAT, getValueOfPercent } from "../../../utils/CommonUtil";


function dateFormatter(cell) {
  if (!cell) {
    return "";
  }
  return `${
    moment(cell).format("YYYY-MM-DD")
      ? moment(cell).format("YYYY-MM-DD")
      : moment(cell).format("YYYY-MM-DD")
    }`;
}

export class Procedures extends Component {
  constructor(props) {
    super(props);
    this.state = {
      search_filter: "code",
      search_key: "",
      page: 1,
      sortName: "",
      sortOrder: "",
      sortBy: "",
      practitioner_id: "",
      patient_id: "",
      diagnosis_string: "",
      isDataFetched: false,
      list: [],
      errorMessage: "",
      isLoading: false
    };
    this.setLoader = this.setLoader.bind(this);
  }


  componentDidMount = async () => {

    if (this.props.state &&
      this.props.state.requested_professional &&
      this.props.state.related_party) {

      this.setState({
        practitioner_id: this.props.state.requested_professional,
        patient_id: this.props.state.related_party
      })

    }

    if (this.props.diagnosis_string) {
      this.setState({
        diagnosis_string: this.props.diagnosis_string
      })
    }

    const payload = this.getPayload();
    await this.props.fetchProceduresList(this.state.page, payload);

    if (this.props.proceduresListData &&
      this.props.proceduresListData.proceduresList &&
      this.props.proceduresListData.proceduresList.PageResult) {
      this.setState({
        list: this.props.proceduresListData.proceduresList.PageResult
      })
    }
    setTimeout(() => {
      this.setState({
        isDataFetched: true,
      });
    }, 1000);

  }

  componentDidUpdate = (prevProps, prevState) => {
    if (prevProps.state.requested_professional !== this.props.state.requested_professional ||
      prevProps.state.related_party !== this.props.state.related_party) {

      //console.log("this.props",this.props);
      this.setState({
        practitioner_id: this.props.state.requested_professional,
        patient_id: this.props.state.related_party
      })

    }
    if (prevProps.diagnosis_string !== this.props.diagnosis_string) {
      this.setState({
        diagnosis_string: this.props.diagnosis_string
      })
    }
  }

  getPayload = () => {
    return {
      search_filter: this.state.search_filter,
      search_key: this.state.search_key,
    };
  }

  callListAPI = async () => {
    this.setState({
      list: []
    })

    const payload = this.getPayload();
    await this.props.fetchProceduresList(this.state.page, payload);

    if (this.props.proceduresListData &&
      this.props.proceduresListData.proceduresList &&
      this.props.proceduresListData.proceduresList.PageResult) {
      this.setState({
        list: this.props.proceduresListData.proceduresList.PageResult
      }, () => {
        setTimeout(() => {
          this.setState({
            isDataFetched: true,
          });
        }, 500);
      })
    } else {
      setTimeout(() => {
        this.setState({
          isDataFetched: true,
        });
      }, 500);
    }

  }

  onSortChange = (sortName, sortOrder) => {
    let sortBy;
    if (sortOrder == "desc") {
      sortBy = "-" + sortName;
    } else {
      sortBy = sortName;
    }
    this.setState({
      sortName,
      sortOrder,
      sortBy,
      page: 1,
      isDataFetched: false,
    }, () => {
      this.callListAPI();
    });

  };

  onPageChange = (page, sizePerPage) => {
    this.setState({
      page,
      isDataFetched: false
    }, () => {
      this.callListAPI();
    });
  };


  handleInputChange = (event) => {
    let val = event.target.value;

    this.setState({
      search_key: val,
      page: 1,
      isDataFetched: false
    }, () => {
      this.callListAPI();
    })
  }

  handleInputSelectChange = (event) => {
    let filterval = event.target.value;

    this.setState({
      [event.target.name]: filterval,
      page: 1,
      isDataFetched: false
    }, () => {
      this.callListAPI();
    })
  }

  


  handleAddProcedure = async (row) => {

   // console.log("Procdedure data", row)

    if (!this.state.practitioner_id || !this.state.patient_id) {
      showAlert("Please select practitioner and patient first!");
      return false;
    }

    if(this.props.state && !this.props.state.appoinment_id){
      showAlert("Please create appointment first!");
      return false;
    }

    this.setState({
      isLoading: true
    })
    const apiPayload = {
      practitioner_id: this.state.practitioner_id,
      patient_id: this.state.patient_id,
      appointment_id: this.props.state && this.props.state.appoinment_id,
      tariff_code: row.Code,
      year:new Date(this.props.state.startdatetime).getFullYear()
    }
    await this.props.fetchProcedureLookup(apiPayload);

    if (!this.props.procedureLookupData.loading && !this.props.procedureLookupData.error) {
      let data = this.props.procedureLookupData.procedureLookup;
      //let payload = {...LineItemObj};
     // console.log("data", data);

      const payload = { ...LineItemObj };

      payload.line_type = "procedure";
      payload.tariff_code = row.Code;
      payload.description = row.Description.substring(0, 70);
      payload.startdatetime = this.props.state && this.props.state.startdatetime ? moment(this.props.state.startdatetime).format("YYYY-MM-DD HH:mm"): "" ;
      payload.enddatetime =  this.props.state && this.props.state.enddatetime ? moment(this.props.state.enddatetime).format("YYYY-MM-DD HH:mm"): "" ;
      payload.numberOfUnits = data && data.NumberOfUnits;
      payload.doctor_id = this.state.practitioner_id;
      payload.reference_id = row.Code;
      //payload.isPrimary = data.isPrimaryUse;
      payload.diagnosis_code = this.state.diagnosis_string;
      let price = 0
      if (data && data.TariffRandSchemeFixed) {
        // check if TariffRandSchemeFixed is exist
        price = Number(data.TariffRandSchemeFixed);
      } else if (data && !data.TariffRandSchemeFixed && data.TariffRandRcfSchemeRate) {
        // check if TariffRandSchemeFixed is not exist and TariffRandRcfSchemeRate exist.
        price = Number(data.TariffRandRcfSchemeRate);
      } else if (data && !data.TariffRandSchemeFixed && !data.TariffRandRcfSchemeRate && data.TariffRandCalculated) {
        // check if TariffRandSchemeFixed and TariffRandRcfSchemeRate is not exist but TariffRandCalculated exist.
        price = Number(data.TariffRandCalculated);
      }

      payload.anestheticUnits  = data && data.anaestheticUnitsRes && data.anaestheticUnitsRes.NumberOfUnits ? Number(data.anaestheticUnitsRes.NumberOfUnits) : 0;
      let anestheticUnitValue = 0;
      if (data && data.anaestheticUnitsRes && data.anaestheticUnitsRes.TariffRcfPublished) {
        // check if TariffRcfPublished is exist
        anestheticUnitValue = Number(data.anaestheticUnitsRes.TariffRcfPublished);
      } else if (data && data.anaestheticUnitsRes && data.anaestheticUnitsRes.TariffRatePublished) {
        // check if TariffRatePublished exist.
        anestheticUnitValue = Number(data.anaestheticUnitsRes.TariffRatePublished);
      }
      
      
      //anestheticUnitValue billing Policy Mulitplier
      anestheticUnitValue = anestheticUnitValue ? getValueOfPercent(anestheticUnitValue, this.props.state && this.props.state.billing_policy_value) : 0;

      //final anesthetic unit value with VAT add inclusive
      payload.anestheticUnitValue = anestheticUnitValue ? anestheticUnitValue: 0;
     // payload.anestheticUnitValue = anestheticUnitValue ? getValWithVAT(anestheticUnitValue): 0; //This is commented based on the confirmation with Estelle that procedures and consultations prices are vat inclusive.

      //final price value with VAT add inclusive
     // price = price ? getValWithVAT(price) : 0; //This is commented based on the confirmation with Estelle that procedures and consultations prices are vat inclusive.

      //billing Policy Mulitplier
      price = price ? getValueOfPercent(price, this.props.state && this.props.state.billing_policy_value) : 0;
      
      if(flateRateConsulations.includes(row.Code) && this.props.state.billing_policy_id===6){
        const firstConsultationConfigurationData=this.props.state.firstConsultationConfiguration.find(item=> (moment(this.props.state.startdatetime).isBetween(moment(item.datefrom), moment(item.dateto))))
        if(firstConsultationConfigurationData){
          price=Number(firstConsultationConfigurationData.consultation_price)          
        }
      }
      //calculating the per unit price by dividing the number of units with price.
      payload.perUnitPrice = price && Number(payload.numberOfUnits) !== 0 ? Number(price) / Number(payload.numberOfUnits) : price;
      payload.base_price = price ? Number(price.toFixed(2)) : 0;
      // console.log("procedure props", this.props)
      if(this.props.claimAsAssistant === 0){
        payload.price = price ? Number(price.toFixed(2)) : 0;
      }
      payload.calculatedPrice = price ? Number(price.toFixed(2)) : 0;
     // console.log("payload", payload)

      this.setState({
        isLoading: false
      })
      this.props.updateState(payload);
    } else {
      this.setState({
        errorMessage: this.props.procedureLookupData.error,
        isLoading: false
      })

      setTimeout(() => {
        this.setState({
          errorMessage: ""
        });
      }, 3000);
    }



  }

  // Adding actions edit and delete icons
  actionsFormatter = (cell, row) => {
    return (
      <div>

        <span title="Add Procedure" onClick={() => this.handleAddProcedure(row)}>
          <i className="fa fa-plus billing-plus-icon ml-2"></i>
        </span>
      </div>
    );
  }

  formatDescription = (cell, row) => {
    if (!cell) {
      return "Not Available"
    }

    return (
      <div className="description" title={cell}>{cell}</div>
    )
  }

  /**
   * This method will be called when there is not data or data is being fetched to show the loader.
   */
  setLoader() {
    if (this.state.isDataFetched) {
      return <p>There is no data to display</p>;
    } else {
      return (
        <div>
          <img src={ttmLoader} alt='loader' className="loader-image" />
        </div>
      );
    }
  }

  /**
  * This method will be called to format the table data for valid data.
  * @param {string} data of the table column.
  * @returns {string} data or Not available string
  */
  checkValidData = (data) => {
    if (!data) {
      return "Not Available";
    } else {
      return data;
    }
  }

  /**
  * This method will be called to format the table data for valid data.
  * @param {string} data of the table column.
  * @returns {string} data with first letter capital or Not available string
  */
  detailFormatter = (data) => {
    if (!data) {
      return "Not Available";
    } else {
      return data ? (data.charAt(0).toUpperCase() + data.slice(1)) : "Not Available";
    }
  }

  //   /**
  //    * This method will clear all the filters which are selected.
  //    */
  //   handleClearFilters = () => {
  //     this.setState({
  //       page: 1,
  //       sortName: "",
  //       sortOrder: "",
  //       sortBy: "",
  //       isDataFetched: false
  //     }, () => {
  //       this.callListAPI();
  //     })
  //   }


  /**
 * This will return filter form HTML for the render method.
 */
  getHeaderFilter = () => {

    return (
      <div className={`row form-group `}>

        <div class="col-md-12 d-flex flex-column flex-md-row">

          <input
            type="text"
            className={`form-control ${style.inputSearch}`}
            name="search_key"
            placeholder="Search here"
            onChange={this.handleInputChange}
            value={this.state.search_key}
          // onChange={this.onSearchChange}
          />
          <div class="d-flex mt-2 mt-md-0">
            <label class="form-control invoice-filter-label border-0">in</label>
            <select
              className="form-control"
              id="search_filter"
              name="search_filter"
              onChange={this.handleInputSelectChange}
              value={this.state.search_filter}
            >
              <option value="code">Code</option>
              <option value="description">Description</option>
            </select>
          </div>
        </div>
      </div>
    );
  };

  render() {
    const listData = this.props.proceduresListData &&
      this.props.proceduresListData.proceduresList &&
      this.props.proceduresListData.proceduresList;

    return (
      <div className="inventory-tab-wrapper flex-wrap">
        <div className="row">
          {/* <div className="col-md-12 d-flex justify-content-md-end">
              <a className="clearFilters"
                href="javascriptVoid:0"
                onClick={this.handleClearFilters}>
                Clear Filters
                </a>
            </div> */}
          <div className="col-md-12">
            {this.getHeaderFilter()}
          </div>
        </div>

        <div className="row">
          <div className={`col-md-12`}>
            <BootstrapTable
              remote={true}
              bordered={false}
              data={this.state.list}
              version="4"
              search={false}
              pagination
              fetchInfo={{
                dataTotalSize: listData && listData.TotalCount ? listData.TotalCount : 0,
              }}
              options={{
                searchvalue: "",
                sortName: this.state.sortName,
                sortOrder: this.state.sortOrder,
                onSortChange: this.onSortChange,
                // onSearchChange: this.onSearchChange,
                sizePerPage: 5,
                page: this.state.page,
                onPageChange: this.onPageChange,
                noDataText: this.setLoader(),
              }}>
              <TableHeaderColumn
                dataField="Code"
                isKey={true}
                dataFormat={this.checkValidData}
                width="10%"
              >
                Code
                </TableHeaderColumn>
              <TableHeaderColumn
                dataField="Description"
                dataFormat={(cell, row) => this.formatDescription(cell, row)}
                width="80%"
              >
                Description
               </TableHeaderColumn>
              <TableHeaderColumn
                dataField="id"
                width="10%"
                dataFormat={this.actionsFormatter}
              >
                Add
               </TableHeaderColumn>
            </BootstrapTable>
            {this.state.isLoading ? (
              <div className={"loadingWrapper"}>
                <img
                  src={ttmLoader}
                  alt="loader"
                  className={style.loading}
                />
              </div>
            ) : (
                <div className={"textCenter"}>
                  {this.state.errorMessage && (
                    <p className=" error-message">
                      {this.state.errorMessage}
                    </p>
                  )}
                </div>
              )}
          </div>
        </div>
      </div>
    );
  }
}

// export default Users;
const mapStateToProps = (state) => {
  return {
    proceduresListData: state.proceduresList,
    procedureLookupData: state.procedureLookup,
  }
};

const mapDispatchToProps = (dispatch) => {
  return {
    fetchProceduresList: (page, payload) => dispatch(fetchProceduresList(page, payload, 10)),
    fetchProcedureLookup: (payload) => dispatch(fetchProcedureLookup(payload)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Procedures);
